import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer';

const EntryLogsReport = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [typeQuery, setTypeQuery] = useState('');
    const [filterType, setFilterType] = useState('All');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [tableKey, setTableKey] = useState(0);
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);

    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );

    const handlePrintGridAction = () => {
        window.print();
    };
    
    useEffect(() => {
        
        setTableKey(prev => prev + 1);
    }, [filterType, fromDate, toDate]);
    const loadEntryLogs = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const token = localStorage.getItem("access_token");

            const res = await API.get(
                "admin/entry-logs-report/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: {
                        page,
                        search,
                        type: typeQuery,
                        from_date: fromDate,
                        to_date: toDate
                    }
                }
            );

            setList(
                Array.isArray(res.data)
                    ? res.data
                    : (res.data.results || [])
            );

            setMobileTotalPages(
                res.data.count
                    ? Math.ceil(res.data.count / 10)
                    : 1
            );

        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };useEffect(() => {

    if (!isMobile) return;

    loadEntryLogs(1, searchQuery);

}, []);

useEffect(() => {

    if (!isMobile) return;

    const timer = setTimeout(() => {

        setMobilePage(1);

        loadEntryLogs(
            1,
            searchQuery
        );

    }, 400);

    return () => clearTimeout(timer);

}, [
    searchQuery,
    typeQuery,
    fromDate,
    toDate
]);

useEffect(() => {

    if (!isMobile) return;

    loadEntryLogs(
        mobilePage,
        searchQuery
    );

}, [mobilePage]);
    
    useEffect(() => {

        const resize = () => {

            setIsMobile(window.innerWidth < 768);

        };

        window.addEventListener("resize", resize);

        return () =>
            window.removeEventListener("resize", resize);

    }, []);

    
    const tableHeaders = ['Date', 'Event Name', 'Participant', 'Passcode', 'Entry Time', 'Exit Time', 'Status'];

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans print:p-0 animate-fadeIn">
            <div className="w-full max-w-8xl mx-auto flex flex-col space-y-6 px-2">
                
                <div className="w-full text-center">
                    <h2 className="text-4xl font-light text-gray-700 mb-4 tracking-tight">Scan Entry Logs Report</h2>
                </div>

                {/* Filters */}
                <form className="w-full bg-white border border-gray-300 px-6 pb-6 pt-2 rounded relative shadow-sm print:hidden">
                    <span className="absolute -top-2.5 left-4 bg-[#F8FAFC] px-2 text-[11px] font-bold text-gray-700 tracking-wide">
                        Logs Report Filters
                    </span>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center text-xs font-bold uppercase text-gray-700 pt-4">
                        <div className="flex flex-col md:flex-row gap-2">
                            <label className="w-full md:w-[30%] text-left md:text-right">Status:</label>
                            <select className="flex-1 p-2 border rounded-md shadow-sm" value={filterType} onChange={(e) => {setFilterType(e.target.value); setTypeQuery(e.target.value);}}>
                                <option value="All">All Status</option>
                                <option value="IN">Entry Only (IN)</option>
                                <option value="OUT">Completed (IN/OUT)</option>
                            </select>
                        </div>
                        <div className="flex flex-col md:flex-row gap-2">
                            <label className="w-full md:w-[30%] text-left md:text-right">From:</label>
                            <input type="date" className="flex-1 p-2 border rounded-md" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                        </div>
                        <div className="flex flex-col md:flex-row gap-2">
                            <label className="w-full md:w-[30%] text-left md:text-right">To:</label>
                            <input type="date" className="flex-1 p-2 border rounded-md" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                        </div>
                    </div>
                    <div className="flex
                    flex-col
                    md:flex-row
                    justify-center
                    gap-3
                    pt-4
                    border-t">
                        <button
                            type="submit"
                            className="w-full md:w-auto px-12 py-2 bg-[#2563EB] rounded-mdbg-[#2563EB] text-white text-xs font-bold uppercase tracking-wider rounded-md hover:bg-blue-800 transition-all cursor-pointer border-none shadow-md active:scale-95"
                        >
                            Search
                        </button>
                    </div>
                </form>

                {/* Data Grid */}
                <div
                className="
                w-full
                bg-white
                rounded-xl
                shadow-sm
                overflow-visible
                md:overflow-hidden
                border
                "
                >
                    <div className="hidden md:block">

                    <TableContainer
                        columns={tableHeaders}
                        key={tableKey}
                        apiUrl="admin/entry-logs-report/"
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        typeQuery={typeQuery}
                        setTypeQuery={setTypeQuery}
                        customActions={
                            <button onClick={handlePrintGridAction} className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs rounded hover:bg-blue-800 shadow-md">
                                Print
                            </button>
                        }
                        
                        renderRow={(log, index, srNo) => (
                            <tr key={index} className="border-b hover:bg-gray-50/80 text-xs font-medium text-gray-700">
                                <td className="py-3 px-2 border-r text-center">{srNo}</td>
                                <td className="py-3 px-2 border-r text-center text-teal-600 font-bold">{log.date}</td>
                                <td className="py-3 px-2 border-r font-bold">{log.event_name}</td>
                                <td className="py-3 px-2 border-r">{log.cust_name}</td>
                                <td className="py-3 px-2 border-r font-mono">{log.passcode}</td>
                                <td className="py-3 px-2 border-r text-center font-bold text-green-700">{log.entry_time}</td>
                                <td className="py-3 px-2 border-r text-center font-bold text-orange-700">{log.exit_time}</td>
                                <td className="py-3 px-2 text-center font-bold">
                                    <span className={`px-2 py-1 rounded text-[10px] ${log.status === 'IN / OUT' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`}>
                                        {log.status}
                                    </span>
                                </td>
                            </tr>
                        )}
                    />
                    </div>
                    <div className="md:hidden mt-4">

                    <input
                    type="text"
                    value={searchQuery}
                    onChange={(e)=>setSearchQuery(e.target.value)}
                    placeholder="Search entry logs..."
                    className="
                    w-full
                    border
                    rounded-lg
                    p-3
                    text-sm
                    outline-none
                    focus:border-blue-500
                    "
                    />
                    <div className="md:hidden space-y-4 mt-4">

                    {
                    loadingCards ?

                    <div className="text-center py-10">

                    Loading...

                    </div>

                    :

                    list.length===0 ?

                    <div className="text-center py-10">

                    No Record Found

                    </div>

                    :

                    list.map((log)=>(

                    <div
                    key={log.passcode}
                    className="
                    bg-white
                    rounded-xl
                    border
                    shadow-sm
                    p-4
                    w-full
                    max-w-full
                    min-w-0
                    overflow-hidden
                    "
                    >

                    <div className="space-y-3">

                    <div>

                    <p className="text-xs text-gray-500">

                    Date

                    </p>

                    <p>{log.date}</p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Event

                    </p>

                    <p>{log.event_name}</p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Participant

                    </p>

                    <p>{log.cust_name}</p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Passcode

                    </p>

                    <p className="break-all">

                    {log.passcode}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Entry Time

                    </p>

                    <p className="text-green-700">

                    {log.entry_time}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Exit Time

                    </p>

                    <p className="text-orange-700">

                    {log.exit_time || "-"}

                    </p>

                    </div>

                    <div>

                    <p className="text-xs text-gray-500">

                    Status

                    </p>

                    <span
                    className={`px-3 py-1 rounded text-xs font-bold ${
                    log.status==="IN / OUT"
                    ? "bg-blue-100 text-blue-800"
                    : "bg-green-100 text-green-800"
                    }`}
                    >

                    {log.status}

                    </span>

                    </div>

                    </div>

                    </div>

                    ))

                    }

                    </div>
                    <div className="md:hidden flex justify-between items-center py-5">

                    <button
                    disabled={mobilePage===1}
                    onClick={()=>setMobilePage(p=>p-1)}
                    className="
                    px-4
                    py-2
                    border
                    rounded
                    disabled:opacity-40
                    "
                    >

                    Previous

                    </button>

                    <span>

                    Page {mobilePage}

                    of

                    {mobileTotalPages}

                    </span>

                    <button
                    disabled={mobilePage===mobileTotalPages}
                    onClick={()=>setMobilePage(p=>p+1)}
                    className="
                    px-4
                    py-2
                    border
                    rounded
                    disabled:opacity-40
                    "
                    >

                    Next

                    </button>

                    </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EntryLogsReport;